// these are mainly used for navigating from the submit step to the correct step number
export enum MerchantApplicationStepType {
  WELCOME = 'welcome',
  VERIFY_YOUR_BUSINESS = 'verify_your_business',
  BANK_ACCOUNT = 'bank_account',
  BUSINESS_DOCUMENTS = 'business_documents',
  SUBMIT = 'submit',
  OTHER = 'other', // placeholder for new steps

  // Verify your business sub steps
  BUSINESS_TYPE_SUB_STEP = 'business_type',
  BUSINESS_DETAILS_SUB_STEP = 'business_details',
  CONTACT_INFORMATION_SUB_STEP = 'contact_information',
  APPLICATION_SIGNER_SUB_STEP = 'application_signer',
  BUSINESS_OWNERS_SUB_STEP = 'business_owners',
  PRODUCTS_AND_SERVICES_SUB_STEP = 'products_and_services',
  PAYMENT_ACCEPTANCE_SUB_STEP = 'payment_acceptance',
  PROCESSING_VOLUMES_SUB_STEP = 'processing_volumes',
}

export enum PaysafeApplicationSteps {
  WELCOME = 0,
  VERIFY_YOUR_BUSINESS = 1,
  BANK_ACCOUNT_STEP = 2,
  SUBMIT_STEP = 3,

  // Verify your business sub steps
  BUSINESS_TYPE_SUB_STEP = 1.1,
  BUSINESS_DETAILS_SUB_STEP = 1.2,
  CONTACT_INFORMATION_SUB_STEP = 1.3,
  APPLICATION_SIGNER_SUB_STEP = 1.4,
  BUSINESS_OWNERS_SUB_STEP = 1.5,
  PRODUCTS_AND_SERVICES_SUB_STEP = 1.6,
  PAYMENT_ACCEPTANCE_SUB_STEP = 1.7,
  PROCESSING_VOLUMES_SUB_STEP = 1.8,
}

export enum TsysApplicationSteps {
  WELCOME = 0,
  VERIFY_YOUR_BUSINESS = 1,
  BANK_ACCOUNT_STEP = 2,
  BUSINESS_DOCUMENTS_STEP = 3,
  SUBMIT_STEP = 4,

  // Verify your business sub steps
  BUSINESS_TYPE_SUB_STEP = 1.1,
  BUSINESS_DETAILS_SUB_STEP = 1.2,
  CONTACT_INFORMATION_SUB_STEP = 1.3,
  APPLICATION_SIGNER_SUB_STEP = 1.4,
  BUSINESS_OWNERS_SUB_STEP = 1.5,
  PRODUCTS_AND_SERVICES_SUB_STEP = 1.6,
  PAYMENT_ACCEPTANCE_SUB_STEP = 1.7,
  PROCESSING_VOLUMES_SUB_STEP = 1.8,
}

export enum NorthApplicationSteps {
  WELCOME = 0,
  VERIFY_YOUR_BUSINESS = 1,
  BANK_ACCOUNT_STEP = 2,
  SUBMIT_STEP = 3,

  // Verify your business sub steps
  BUSINESS_TYPE_SUB_STEP = 1.1,
  BUSINESS_DETAILS_SUB_STEP = 1.2,
  CONTACT_INFORMATION_SUB_STEP = 1.3,
  APPLICATION_SIGNER_SUB_STEP = 1.4,
  BUSINESS_OWNERS_SUB_STEP = 1.5,
  PRODUCTS_AND_SERVICES_SUB_STEP = 1.6,
  PAYMENT_ACCEPTANCE_SUB_STEP = 1.7,
  PROCESSING_VOLUMES_SUB_STEP = 1.8,
}

export const MerchantAppMissingFields = {
  BusinessTypeSubStep: {
    BUSINESS_TYPE: 'Business type',
  },
  BusinessDetailsSubStep: {
    LEGAL_NAME: 'Legal Business Name',
    BUSINESS_ID: 'Tax ID',
    DBA: 'Doing Business As',
    DATE_OF_INC: 'Date of Incorporation',
    STREET: 'Legal Business Street Address',
    CITY: 'City',
    STATE: 'State',
    POSTAL: 'Postal Code',
  },
  ContactInfoSubStep: {
    PHONE: 'Customer Support Phone Number',
    EMAIL: 'Customer Support Email',
    WEBSITE: 'Company Website',
  },
  ApplicationSignersSubStep: {
    NO_APPLICATION_SIGNER: 'An Application signer is required.',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    SSN: 'Social Security Number',
    PHONE: 'Phone Number',
    DOB: 'Date of Birth',
    JOB_TITLE: 'Job Title',
    OWNERSHIP: 'Ownership percent',
    STREET: 'Street Address',
    CITY: 'City',
    STATE: 'State',
    POSTAL: 'Postal Code',
    PREV_STREET: 'Previous Street Address',
    PREV_CITY: 'Previous City',
    PREV_STATE: 'Previous State',
    PREV_POSTAL: 'Previous Postal Code',
    EMAIL: 'Email Address',
  },
  BusinessOwnersSubStep: {
    NO_OWNERS: 'At least one Business owner is required.',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    SSN: 'Social Security Number',
    PHONE: 'Phone Number',
    DOB: 'Date of Birth',
    JOB_TITLE: 'Job Title',
    OWNERSHIP: 'Ownership percent',
    STREET: 'Street Address',
    CITY: 'City',
    STATE: 'State',
    POSTAL: 'Postal Code',
    OWNERSHIP_TOTAL: 'No business owner with greater than 0% ownership',
  },
  ProductsAndServicesSubStep: {
    INDUSTRY: 'Industry',
    PRODUCT_DESCRIPTION: 'Product and Services Description',
    FULFILLMENT_TIMEFRAME: 'Fulfillment Timeframe',
    PERCENT_B2B: 'Percent Business-to-business',
  },
  PaymentAcceptanceSubStep: {
    PREVIOUS_PROCESSOR: 'Previous payment processor',
    STATEMENT_DESCRIPTOR: 'Statement Descriptor',
    TRX_PERCENTS: 'Checkout Method Percentages',
    NUMBER_OF_TERMINALS: 'Number of Terminals',
  },
  VolumesSubStep: {
    MONTHLY_VOLUME: 'Monthly Processing Volume',
    HIGH_TICKET_AMOUNT: 'High Ticket Amount',
    AVERAGE_AMOUNT_CARD: 'Credit Card - Average Transaction Amount',
    AVERAGE_AMOUNT_DEBIT: 'Bank-to-bank - Average Transaction Amount',
    AVERAGE_TRX_PER_MONTH: 'Number of Transactions Per Month',
  },
  BusinessDocumentsStep: {
    BUSINESS_DOCS: 'Business Documents',
    AOI_DOCUMENT: 'Articles of Incorporation Document Upload',
    AOI_ISSUED_AT: 'Articles of Incorporation Issued Date',
    AOI_STATE: 'Articles of Incorporation State',
    BL_DOCUMENT: 'Business License Document Upload',
    BL_EXPIRES_AT: 'Business License Expiry Date',
    BL_ISSUED_AT: 'Business License Issued Date',
    BL_STATE: 'Business License State',
    BL_NAME: 'Business License Name',
    DOCUMENT_501C3: '501c3 Document Upload',
    BANK_STATEMENT: 'Bank Statement Document Upload',
    PROCESSING_STATEMENT: 'Processing Statement Document Upload',
  },
  BankAccountStep: {
    ACCOUNT_NUMBER: 'Account Number',
    ROUTING_NUMBER: 'Routing Number',
    ROUTING_NUMBER_CA: 'Transit Number and Institution ID',
    TYPE: 'Account Type',
    ACCOUNT_HOLDER_NAME: 'Account Holder or Business Name',
    BANK_NAME: 'Bank Name',
    DOC_UPLOAD: 'Upload a Bank Letter or Voided Check',
  },
};
